/* This example requires Tailwind CSS v2.0+ */
import { Primary } from "../buttons/Primary";

const features = [
  {
    title: "Cupo aprobado",
    titleValue: "$350,000",
  },
  {
    item: "Interés corriente",
    value: "$5,483",
  },
  {
    item: "Administración",
    value: "$60,000",
  },
  {
    item: "IVA",
    value: "$11,400",
  },
  {
    title2: "Total a pagar",
    title2Value: "$426,883",
  },
];

export function Example() {
  return (
    <div className="overflow-hidden bg-grayM font-walsheim text-tdark">
      <div className="max-w-7xl mx-auto py-28 px-6 lg:px-8">
        <div className="grid justify-items-center">          
          <div className="bg-purpleLight rounded-md lg:w-1/2 px-6 lg:px-20 py-10">
            <div className="text-center">
              <h2 className="pt-8 lg:pt-0 text-4xl font-bold tracking-tight sm:text-5xl">
                Ejemplo de tu crédito en Galilea
              </h2>
              <h3 className="tracking-tight text-lg lg:py-4 lg:px-10">
                A continuación verás el ejemplo de un crédito digital con plazo a 30 días
              </h3>
            </div>
            <dl className="grid grid-cols-2 mt-10">
              <ul className="space-y-4 text-lg w-full">
                {features.map((feature) => (
                  <>
                    <li key={feature.name}>
                      <h1 className="font-bold">{feature.title}</h1>
                    </li>
                    <li key={feature.name} className="">
                      <dd className="text-lg">{feature.item}</dd>
                    </li>
                    <li key={feature.name}>
                      <h1 className="font-bold">{feature.title2}</h1>
                    </li>
                  </>
                ))}
              </ul>
              <ul className="space-y-4 text-lg text-right w-full">
                {features.map((feature) => (
                  <>
                    <li key={feature.name}>
                      <h1 className="font-bold">{feature.titleValue}</h1>
                    </li>
                    <li key={feature.name} className="">
                      <dd className="text-lg">{feature.value}</dd>
                    </li>
                    <li key={feature.name}>
                      <h1 className="font-bold">{feature.title2Value}</h1>
                    </li>
                  </>
                ))}
              </ul>
            </dl>
            <div className="pt-4">
              <div className="">
                <span>Sin letra pequeña: La tarifa de administración es opcional y te permite realizar tu crédito de manera 100% digital sin complicaciones, aunque, también puedes tramitar tu solicitud en físico haciendo <a href="/fisico" className="text-purple underline">clic aquí</a></span>
              </div>
              {/* <div className="lg:flex">
                <div className="block lg:w-1/2 py-2">
                  <a href="/registrarse" className="w-52 pb-10 md:mx-0 mx-auto">
                    <Primary text="Aplicar ahora" />
                  </a>
                </div>
                <div className="pl-2 block lg:w-1/2 py-2">
                  <a href="/tarifas" className="w-52 pb-10 md:mx-0 mx-auto"></a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
